module.exports = __webpack_public_path__ + "assets/img/pegi-es.73e9f6f7.png";